import React,{Component} from 'react'
import {Link} from 'react-router-dom';

 import './style.css'
 export default class Photos extends Component{
  render(){
    return(
      <div className="col-lg-3 col-md-4">
      <div className="portfolio-item wow fadeInUp">
        <div  className="portfolio-popup">
          <img src={this.props.PhotoSrc} alt=""/>
          <div className="portfolio-overlay">
          </div>
        </div>
      </div>
    </div> 
    );
  }
}
 